<template>
  <div>
    <button class="btn btn-sm btn-icon pad-left-0" 
      @click="goBack" 
    ><i class="fa fa-chevron-circle-left"></i>&nbsp;Back</button>

    <div class="pad-btm-30">
      <h2 class="input-panel__head panel-facility__head input-panel__head--align-l"
        v-if="facilitySet && setMatchesVisible"
      >
        <template v-for="(ancestor, index) in facilityPath" :key="ancestor">
          <ancestor  
            :id="ancestor" 
            :ordinal="index + 1"
          ></ancestor>   
          <br v-if="index + 1 === 2">
        </template>

        <ancestor :id="facilitySelection.id"></ancestor> 
      </h2>

      <h2 class="input-panel__head panel-facility__head input-panel__head--align-l"
        v-else-if="inlineFacilityPath.length > 0"
      >
        <template v-for="(ancestor, index) in inlineFacilityPath" :key="ancestor">
          <ancestor  
            :id="ancestor" 
            :ordinal="index + 1"
          ></ancestor>
          <br v-if="index + 1 === 2">
        </template>
      </h2>

      <h2 class="input-panel__head panel-facility__head input-panel__head--align-l"
        v-else
        v-html="breadcrumbs"
      ></h2>
      <form class="panel-facility__form"
        :class="{ 'panel-facility__form--two-col': dualColumns }"
      >
        <div v-if="optionsType === 'radio'">
          <div class="panel-facility__row" 
            v-for="option in optionSet"
          >
            <fieldset>
              <input type="radio" 
                :id="optionSlug(option.id)" 
                :value="option.name"
                :name="optionSetId"
                :checked="optionChecked(option.id)"
                @change="selectOption(
                  option.id, 
                  option.name, 
                  facilityCategory.id, 
                  option.parents, 
                  option.options, 
                  option.checkboxOptions, 
                  option.displayInline,
                  option.displayName,
                  option.twoColumns
                )"
              >
              <label :for="optionSlug(option.id)">
                {{ option.name }}
              </label>
              <facility-suboptions
                :option-set="option.options" 
                :parent-id="option.id"
                :parent-facility-type="facilityType"
                :parent-pending-selection="pendingSelection"
                :type="suboptionType(option.checkbox_options)"
                :require-selection="option.requireSelection"
                @showModal="showModal"
                @setParentFacilityType="setLocalFacilityType"
                @setParentCheckboxSelections="setCheckboxSelections"
                @allowUserProfileName="allowUserProfileName"
                @disableUserProfileName="disableUserProfileName"
              ></facility-suboptions>
            </fieldset>
          </div>
        </div>

        <div v-show="facilitySelection.id">
          <hr>
          <button class="btn btn-sm" 
            @click.prevent="toggleModal"
            :disabled="!userProfileNameAllowed"
          >Set Facility Profile Name</button>
        </div>
      </form>

      <div class="overlay" v-show="modalVisible">
        <transition name="slideDown"> 
          <div class="overlay__inner" v-show="modalVisible" @click.stop>
            <button class="btn btn-sm btn-icon pad-left-0 mrgn-btm-5" 
              @click.prevent="hideModal" 
            ><i class="fa fa-chevron-circle-left"></i>&nbsp;Back</button>
            <form>
              <label for="custom-profile-name">Enter a name for the selected profile (Max {{ maxNameLength }} char.)</label>
              <input id="custom-profile-name" type="text" placeholder="Optional Price Request Name"
                @input="limitNameLength"
                ref="custom-profile-name" 
                v-model="profileName" 
              >
              <button class="btn btn-sm" 
                @click.prevent="setFacilityProfileName"
              >Enter</button>
            </form>
          </div>
        </transition>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import FacilityAncestor from '../AncestorLabel.vue'
import FacilitySuboptions from './FacilitySuboptions.vue'
import router from '../../../router'

export default {
  components: {
    'facility-suboptions' : FacilitySuboptions,
    'ancestor' : FacilityAncestor
  },
  props: [
    'option-set',
    'require-selection'
  ],
  data() {
    return { 
      optionSetId: 'option-set-'+this._uid,
      showSuboptions: null,
      profileName: '',
      modalVisible: false,
      checkboxSelections: [],
      checkboxSelectionsParent: null,
      facilityType: {},
      initialCheckboxSelections: [],
      pendingSelection: null,
      userProfileNameAllowed: true,
      maxNameLength: 50,
    }
  },
  computed: {
    facilityProfiles() {
      return this.$store.getters.facilityProfiles
    },
    facilityCategory() {
      return this.$store.getters.facilityCategory
    },
    facilitySelection() {
      return this.$store.getters.facilityType
    },
    facilitySelectionId() {
      return this.facilitySelection.id
    },
    facilityCheckboxSelections() {
      return this.$store.getters.facilityCheckboxSelections
    },
    facilityProfileName() {
      return this.$store.getters.facilityProfileName
    },
    inlineFacilityPath() {
      return this.$store.getters.inlineFacilityPath
    },
    utilityId() {
      return this.$store.getters.utilityId
    },
    optionsType() {
      if (this.facilityCategory.checkboxOptions === 1) {
        return 'checkbox'
      } 
      return 'radio'
    },
    facilitySet() {
      if (this.facilitySelection.id) {
        return true
      }
      return false
    },
    setMatchesVisible() {
      if (this.facilitySet && this.facilitySelection.parents.indexOf(this.facilityCategory.id) > -1) {
        return true
      } 
      return false
    },
    dualColumns() {
      if (this.facilityCategory.twoColumns > 0) {
        return true
      }
      return false
    },
    breadcrumbs() {
      if (!this.facilityCategory.parents) {
        return this.facilityCategory.name
      } else {
        let path = ''
        let parentsReversed = this.facilityCategory.parents.slice()
        parentsReversed = parentsReversed.reverse()

        for (var i = 0; i < parentsReversed.length; i++) {
          path += '<span class="panel-facility__level">'+this.categoryName(parentsReversed[i])+': </span>'
        }

        path += '<span class="panel-facility__level">'+this.facilityCategory.name+'</span>'

        return path
      }
    },
    closestAncestor() {
      if (this.facilityCategory.parents) {
        return this.facilityCategory.parents[this.facilityCategory.parents.length - 1];
      }
      return false
    },
    checkboxSelectionCount() {
      // The number of checkboxes selected
      return Object.keys(this.checkboxSelections).length
    },
    facilityPath() {
      if (this.facilityTree) {
        let tree = this.facilityTree.slice()
        let path = []
        let threshold = 0

        for (let i = 0; i < tree.length; ++i) {
          path.push(tree[i])
        }

        return path
      }

      return false
    },
    facilityTree() {
      if (this.facilitySelection.parents) {
        let parents = this.facilitySelection.parents.slice()
        parents = parents.reverse()
        return parents
      }
      return false
    },
    facilityAncestorCount() {
      if (this.facilityTree) {
        return this.facilityTree.length
      }
      return 0
    }
  },
  methods: {
    goBack() {
      this.$store.dispatch('clearInlineFacilityPath')

      if (!this.closestAncestor) {
        this.$store.dispatch('clearFacilityCategory')

      } else {
        let targetCategory = this.getObject(this.facilityProfiles, this.closestAncestor)

        this.$store.dispatch('setFacilityCategory', {
          id: targetCategory.id,
          name: targetCategory.name,
          thumb: '',
          parents: targetCategory.parents,
          options: targetCategory.options,
          checkboxOptions: targetCategory.checkboxOptions,
        })
      }

      // this.$store.dispatch('clearFacilityCheckboxSelections')
    },
    getObject(theObject, id) {
      let result = null;
      if (theObject instanceof Array) {
        for(let i = 0; i < theObject.length; i++) {
          result = this.getObject(theObject[i], id)
          if (result) {
            break;
          }
        }
      } else {
        for (let prop in theObject) {
          if (prop == 'id') {
            if (theObject[prop] == id) {
              return theObject;
            }
          }

          if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
            result = this.getObject(theObject[prop], id)
            if (result) {
              break;
            }
          } 
        }
      }
      return result
    },
    suboptionType(val) {
      switch(val) {
        case 0:
          return 'radio'
        case 1: 
          return 'checkbox'
        default:
          return 'radio'
      }
    },
    setLocalFacilityType(id, name, category, parents, displayName) {
      this.facilityType = {
        id: id,
        name: name,
        category: category,
        parents: parents,
        displayName: displayName,
      }
    },
    selectOption(id, name, category, parents, suboptions, checkboxOptions, displayInline, displayName, twoColumns) {   
      this.disableUserProfileName();

      this.pendingSelection = id

      let inline = false
      if (displayInline && displayInline === 1) {
        inline = true
      }

      let checkboxes = false 
      if (checkboxOptions && checkboxOptions === 1) {
        checkboxes = true
      }

      this.$store.dispatch('clearInlineFacilityPath')

      if (this.facilityCheckboxSelections && this.facilityCheckboxSelections.length > 0 && this.checkboxSelectionsParent) {

        if (this.facilityCheckboxSelections[0].parentId != id) {
          this.checkboxSelections = []
          this.checkboxSelectionsParent = null
        }
      } 
      
      if (!suboptions || suboptions.length === 0) {
        // If there are no suboptions, set the facility type
        this.setLocalFacilityType(id, name, category, parents, displayName)

        this.showModal()
        
      } else if (checkboxes === true) {
        
        // If there are checkbox suboptions, set the facility type
        // and show the sub options
        this.setLocalFacilityType(id, name, category, parents, displayName)

        if (suboptions.length < 4 || inline === true) {
          this.showSuboptions = id
        
        } else {

          this.$store.dispatch('setFacilityCategory', {
            id: id,
            name: name,
            thumb: '',
            parents: parents,
            options: suboptions,
            twoColumns: twoColumns,
            checkboxOptions: checkboxOptions,
          })
        }

      } else if (suboptions.length < 4 || inline === true) {
        // If there are less than 4 suboptions or they're manually set 
        // to inline, show them inline
        // if (this.facilitySelection.id) {
        //   this.$store.dispatch('clearFacilityType')
        //   this.clearFacilityCheckboxSelections()
        // }

        let parentsReversed = parents.slice()
        parentsReversed = parentsReversed.reverse()
        
        let inlinePath = []
        for (let i = 0; i < parentsReversed.length; i++) {
          inlinePath[i] = parentsReversed[i]
        }

        inlinePath.push(id)
        this.$store.dispatch('setInlineFacilityPath', inlinePath)

        this.showSuboptions = id

      } else {
        // Set the facility category to the selected item
        this.$store.dispatch('setFacilityCategory', {
          id: id,
          name: name,
          thumb: '',
          parents: parents,
          options: suboptions,
          twoColumns: twoColumns,
          checkboxOptions: checkboxOptions,
        })
      }
    },
    setCheckboxSelections(checkboxSelections) {
      this.clearFacilityCheckboxSelections()

      // setTimeout(() => {
      //   this.clearFacilityCheckboxSelections
      //   this.checkboxSelections = checkboxSelections
      // }, 1)

      this.checkboxSelections = checkboxSelections
    },
    selectCheckbox(id, name, displayName, suboptions) {
      let obj = {
        id: id,
        name: name,
        displayName: displayName,
        suboption: {},
      }

      if (this.checkboxSelected(id)) {
        let checkboxSet = this.checkboxSelections.filter(function(option) {
          return option.id != id
        })
        this.checkboxSelections = checkboxSet

      } else {
        this.checkboxSelections.push(obj)
      }      
    },
    selectCheckboxSuboption(parentId, option) {
      // Add suboption to parent checkbox selection
      for (let i = 0; i < this.checkboxSelections.length; i++) {
        if (this.checkboxSelections[i].id === parentId) {
          this.checkboxSelections[i].suboption = {
            id: option.id,
            name: option.name,
            displayName: option.displayName
          }
        }
      }
    },
    checkboxSelected(id) {
      let checkboxSet = this.checkboxSelections.filter(function(option) {
        return option.id === id
      })

      if (Object.keys(checkboxSet).length > 0) {
        return true
      } else {
        return false
      }
    },
    optionChecked(id) {
      if (this.pendingSelection) {

        if (id === this.pendingSelection) {
          return true
        } else {
          return false
        }
      }

      if (id === this.facilitySelection.id) {
        return true

      } else if (this.showSuboptions && this.showSuboptions === id) {
        return true

      } else if (this.facilitySelection.parents && this.facilitySelection.parents.indexOf(id) > -1) {
        this.showSuboptions = id
        return true
      }

      return false
    },
    clearFacilityCheckboxSelections() {
      this.$store.dispatch('clearFacilityCheckboxSelections')
      this.checkboxSelections = []
      this.checkboxSelectionsParent = null
    },
    categoryName(id) {
      let targetCategory = this.getObject(this.facilityProfiles, id)
      return targetCategory.name
    },
    optionSlug(id) {
      return 'facility-option-'+id
    },
    toggleModal() {
      this.modalVisible = !this.modalVisible
      this.pendingSelection = null

      if (this.modalVisible) {
        this.focusProfileName()
      }
    },
    hideModal() {
      this.modalVisible = false
      this.pendingSelection = null
    },
    showModal() {
      this.modalVisible = true
      this.focusProfileName()
    },
    allowUserProfileName() {
      this.userProfileNameAllowed = true
    },
    disableUserProfileName() {
      // Updated on 2023-01-24 to always allow.
      // this.userProfileNameAllowed = false
    },
    setFacilityProfileName() {
      this.pendingSelection = null

      this.$store.dispatch('clearCustomFacilityVolume')

      this.$store.dispatch('setFacilityType', {
        id: this.facilityType.id,
        name: this.facilityType.name,
        category: this.facilityType.category,
        parents: this.facilityType.parents,
        displayName: this.facilityType.displayName
      })

      this.$store.dispatch('clearFacilityCheckboxSelections')

      if (this.checkboxSelections) {
        let obj = []

        for (let i = 0; i < this.checkboxSelectionCount; ++i) {
          obj[i] = {
            id: this.checkboxSelections[i].id,
            name: this.checkboxSelections[i].name,
            displayName: this.checkboxSelections[i].displayName,
            suboption: this.checkboxSelections[i].suboption,
            parentId: this.checkboxSelections[i].parentId
          }    
        }

        let filteredCheckboxSelections = obj.filter((item) => {
          return item.parentId === this.facilityType.id
        })

        this.$store.dispatch('setFacilityCheckboxSelections', filteredCheckboxSelections)
      }

      this.$store.dispatch('setFacilityProfileName', this.profileName)

      router.push({ name: 'Volume' })
    },
    focusProfileName() {
      setTimeout(() => {
        this.$refs['custom-profile-name'].focus()
      }, 10) 
    },
    limitNameLength() {
      if (this.profileName.length > this.maxNameLength) {
        this.profileName = this.profileName.slice(0, this.maxNameLength)
      }
    }
  },
  created() {
    if (this.facilitySelection) {
      this.allowUserProfileName()
      this.facilityType = this.facilitySelection
    }

    if (this.facilityProfileName) {
      this.profileName = this.facilityProfileName
    }

    // If checkbox selections exist in the store
    if (this.facilityCheckboxSelections && this.facilityCheckboxSelections.length > 0) {
      
      let firstCheckbox = this.facilityCheckboxSelections[0].id

      axios.get('/pricing-calculator/facility-profiles/' + this.utilityId + '/profile/' + firstCheckbox)
        .then(response => {   
          this.checkboxSelectionsParent = response.data.parent_id
        })

      if (this.facilityCheckboxSelections.length > 0) {        
        for (let i = 0; i < this.facilityCheckboxSelections.length; i++) {

          this.checkboxSelections.push({
            id: this.facilityCheckboxSelections[i].id,
            name: this.facilityCheckboxSelections[i].name,
            displayName: this.facilityCheckboxSelections[i].displayName,
            suboption: this.facilityCheckboxSelections[i].suboption,
            parentId: this.facilityCheckboxSelections[i].parentId
          })
        }
      }
    }
  }
}
</script>
